import { Flex, Span } from "@ir/ui";
import { ReactNode } from "react";

interface PromoDetailInfoRowProps {
  label: string;
  value: ReactNode;
  valueClassName?: string;
}

export const PromoDetailInfoRow = ({ label, value, valueClassName = "text-grey-700" }: PromoDetailInfoRowProps) => (
  <Flex
    align="center"
    justifyContent="space-between"
    className="promo-detail-info-row py-1 px-4"
  >
    <Span className="text-grey-600 text-sm">{label}</Span>
    <Span className={`text-sm font-medium text-right ${valueClassName}`}>{value}</Span>
  </Flex>
);
